import { OnInit, Component, Input } from '@angular/core';
import { RegistroIngSalActivoFijo } from 'src/app/shared/models/registroIngSalActivoFijo.model';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-mostrar-info-activo-fijo-modal',
  templateUrl: './mostrar-info-activo-fijo-modal.component.html',
  styleUrls: ['./mostrar-info-activo-fijo-modal.component.scss']
})
export class RegistroActivosFijosModalComponent implements OnInit {

  @Input() public registroActivosFijos: RegistroIngSalActivoFijo;
  registros;
  estado: string;
  observaciones: string;

  constructor(
    private activeModal: NgbActiveModal
  ) { }

  ngOnInit() {
    this.registros = this.registroActivosFijos;
  }

  close(tipo) {

    this.activeModal.close({ respuesta: tipo, observacionesDiligenc: this.observaciones  });
  }


}
